import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PhotoEstimator from "@/components/PhotoEstimator";
import QuoteEngine from "@/components/QuoteEngine";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import FAQ from "@/components/FAQ";
import JoinRepairer from "@/components/JoinRepairer";
import Footer from "@/components/Footer";

export default function LandingPage() {
    return (
        <div data-testid="landing-page" className="bg-carbon text-slate-100">
            <Header />
            <main>
                <Hero />
                <PhotoEstimator />
                <Services />
                <WhyUs />
                <QuoteEngine />
                <Process />
                <FAQ />
                <JoinRepairer />
            </main>
            <Footer />
        </div>
    );
}
